module.exports = __webpack_public_path__ + "img/province.968494a7.jpeg";